(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  let paused = false;
  try { paused = sessionStorage.getItem('mbs-motion-paused') === '1'; } catch (_) {}
  let observer, active = new Set(), progress = [], pending = false;
  const update = () => {
    pending = false;
    if (reduce.matches || paused) return;
    const height = innerHeight;
    active.forEach(el => {
      if (!el.isConnected) { active.delete(el); return; }
      const frame = el.closest('[data-mbs-motion]') || el;
      const bounds = frame.getBoundingClientRect();
      const amount = Math.max(-1, Math.min(1, (height/2 - bounds.top - bounds.height/2) / height));
      el.style.transform = `translate3d(0,${amount * Number(el.dataset.mbsParallax || 20)}px,0)`;
    });
    progress.forEach(root => {
      const bounds = root.getBoundingClientRect();
      const ratio = Math.max(0, Math.min(1, (height*.88 - bounds.top) / (height*.65)));
      root.querySelectorAll('.mbs-word').forEach((word,i,list) => word.classList.toggle('is-read', i / list.length <= ratio));
    });
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
  function init(root = document) {
    root.querySelectorAll('[data-mbs-progress]').forEach(el => {
      const heading = el.querySelector('.mbs-reading');
      if (!heading || heading.dataset.words) return;
      heading.dataset.words = '1';
      const words = heading.textContent.trim().split(/\s+/);
      heading.setAttribute('aria-label', heading.textContent.trim());
      heading.replaceChildren(...words.flatMap((word,i) => {
        const span = document.createElement('span'); span.className='mbs-word'; span.textContent=word; span.setAttribute('aria-hidden','true');
        return i ? [document.createTextNode(' '),span] : [span];
      }));
    });
    progress = [...document.querySelectorAll('[data-mbs-progress]')];
    if (observer) root.querySelectorAll('[data-mbs-reveal],[data-mbs-parallax]').forEach(el => observer.observe(el));
    schedule();
  }
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(entries => entries.forEach(({target,isIntersecting}) => {
      if (target.hasAttribute('data-mbs-reveal') && isIntersecting) { target.classList.add('is-visible'); if (!target.hasAttribute('data-mbs-parallax')) observer.unobserve(target); }
      if (target.hasAttribute('data-mbs-parallax')) isIntersecting ? active.add(target) : active.delete(target);
      schedule();
    }), {rootMargin:'30px 0px',threshold:0.08});
    document.documentElement.classList.add('mbs-motion-ready');
  }
  init();
  if (document.querySelector('.mbs-section')) {
    const toggle = document.createElement('button'); toggle.type='button'; toggle.className='mbs-motion-toggle';
    const sync = () => {
      document.documentElement.classList.toggle('mbs-motion-paused', paused || reduce.matches);
      toggle.setAttribute('aria-label', paused ? 'Beweging inschakelen' : 'Beweging pauzeren');
      toggle.setAttribute('aria-pressed', String(paused)); toggle.textContent = paused ? '▷' : 'Ⅱ'; toggle.title = toggle.getAttribute('aria-label');
      schedule();
    };
    toggle.addEventListener('click',()=>{paused=!paused;try{sessionStorage.setItem('mbs-motion-paused',paused?'1':'0');}catch(_){} sync();});
    document.body.append(toggle); reduce.addEventListener('change',sync); sync();
  }
  addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',()=>{progress=progress.filter(el=>el.isConnected);});
})();
